import { Box } from "@mui/material"
import { useReportFoliosDetailContext } from "../../hooks/useReportFoliosContext"
import { ReassignProviderModal, ReassigAreaAndDepartmentModal, CancelFolioModal } from "./options"
import { useEffect, useState } from "react"
import { reportFolioServices } from "../../../../../../../../utils/constants/callService"
import { useGetData } from "../../hooks/useGetData"
import { useParams } from "react-router-dom"
import { DataDetail } from "../../types"

const OptionSelected = ({ refresh, data }: { refresh: () => void, data: DataDetail }) => {
    const { optionSelected } = useReportFoliosDetailContext()
    const [ReassingModal, setReassingModal] = useState(false)
    const [ReassingModalProvider, setReassingModalProvider] = useState(false)
    const [cancelFolioModal, setCancelFolioModal] = useState(false)
    const { id } = useParams()
    //const { data } = useGetData({ id })


    useEffect(() => {
        if (!optionSelected?.value) return

        const value = optionSelected.value.toString()

        switch (value) {
            case '2':
                setReassingModal(true)
                break
            case '6':
                setReassingModalProvider(true)
                break
            case '4':
                setCancelFolioModal(true)
                break
            case '7':
                if (data?.right?.reportUrl) {
                    window.open(data.right.reportUrl, '_blank')
                } else {
                    reportFolioServices.generateReportFolio({ id: Number(id) ?? '' }).then((response) => {
                        if (response.reportUrl) {
                            window.open(response.reportUrl, '_blank')
                        }
                    })
                }
                break
            default:
                break
        }
    }, [optionSelected, /* data, */ id])

    const chooseComponent = () => {
        if (ReassingModal) {
            return (
                <ReassigAreaAndDepartmentModal
                    open={ReassingModal}
                    onClose={() => setReassingModal(false)}
                    refresh={refresh}
                />
            )
        }
        if (ReassingModalProvider) {
            return (
                <ReassignProviderModal
                    open={ReassingModalProvider}
                    onClose={() => setReassingModalProvider(false)}
                    refresh={refresh}
                />
            )
        }
        if (cancelFolioModal) {
            return (
                <CancelFolioModal
                    open={cancelFolioModal}
                    onClose={() => setCancelFolioModal(false)}
                    refresh={refresh}
                />
            )
        }
        return null
    }

    return <Box>{chooseComponent()}</Box>
}

export { OptionSelected }
